import React, { useState } from "react";
import "./Cruise_Booking.css";
import Common_Btn_Yellow from "../../../common_component/common_btn_yellow/Common_Btn_Yellow";
import Common_Inquiry_Form from "../../../common_component/common_inquiry_form/Common_Inquiry_Form";
import Success_Modal from "../../../contact-us/success_modal/Success_Modal";

const Cruise_Booking = ({ onClick, data }) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSuccess = () => {
    setShowSuccessModal(true);

    setTimeout(() => {
      setShowSuccessModal(false);
    }, 3000);
  };

  return (
    <div className="booking-sidebar">
      <div className="price-card">
        <div className="price-top">
          <span className="old-price">₹ {data?.original_price}</span>
          <span className="discount">({data?.discount_percent}% OFF)</span>
        </div>

        <div className="new-price">
          ₹ {data?.discounted_price} <span>/ Adult</span>
        </div>

        <p className="tax-text">Excluding applicable taxes</p>

        <div className="book-btn">
          <Common_Btn_Yellow
            text="Book Now"
            onClick={() => {
              // setShowSuccessModal(true);
              // setTimeout(() => {
              //   setShowSuccessModal(false);
              // }, 3000);
            }}
          />
        </div>
      </div>

      <div className="form-card">
        <h5 className="cruise-title">Package Enquiry</h5>

        {/* <div className="form-price">
          ₹2,30,500 <span>/ Adult</span>
        </div> */}

        <Common_Inquiry_Form onClick={handleSuccess} />
      </div>

      <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        successText="Tour Booked!"
      />
    </div>
  );
};

export default Cruise_Booking;
